import React, { Component } from "react";
import styles from "./controlPoints.module.scss";
import { withLogisticControlPoints } from "../../../shared/containers/containerLogisticControlPoints";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { withGeocoder } from "../../../shared/containers/containerGeocoder";
import GeocoderSearch from "../../Geocoders/GeocoderSearch";
import MapCreateControlPoint from "./MapCreateControlPoint";
import { TextField } from "@mui/material";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";

const isChange = (controlPoint) => {
  if (controlPoint.title === "" || controlPoint.title === null) return false;
  if (controlPoint.address === "" || controlPoint.address === null) return false;

  return true;
};

class CreateControlPoint extends Component {
  constructor(props) {
    super(props);

    this.state = {
      controlPoint: null,
      isChange: false,
    };
  }

  componentDidMount() {
    const { logisticSelectedControlPoint } = this.props;

    this.setState({ controlPoint: logisticSelectedControlPoint, isChange: false });
  }

  onCloseClick() {
    const { onSelectControlPoint, onSetViewPanel, viewPanelItems } = this.props;

    onSelectControlPoint(null);
    onSetViewPanel(viewPanelItems.controlPointsList);
  }

  onHandleChangeStore(name, value, number = false) {
    const { controlPoint } = this.state;

    controlPoint[name] = number ? parseInt(value === "" || value === null ? (name === "radius" ? "1" : "0") : value) : value;
    this.setState({ controlPoint: controlPoint, isChange: isChange(controlPoint) });
  }

  onHadleSelectSearchResult(item) {
    const { controlPoint } = this.state;

    controlPoint.latitude = item.lat;
    controlPoint.longitude = item.lon;
    controlPoint.address = item.displayName;
    controlPoint.geocoderAddress = item.displayName;

    this.setState({ controlPoint: controlPoint, isChange: isChange(controlPoint) });
  }

  onLocationChange(item, address) {
    const { controlPoint } = this.state;

    controlPoint.latitude = item.lat;
    controlPoint.longitude = item.lng;
    controlPoint.geocoderAddress = address;

    this.setState({ controlPoint: controlPoint, isChange: isChange(controlPoint) });
  }

  onSaveHandler() {
    const { controlPoint } = this.state;
    const { onUpdateControlPoint, onCreateControlPoint } = this.props;

    if (controlPoint.id !== null) {
      onUpdateControlPoint(controlPoint);
      this.setState({ isChange: false });
    }

    if (controlPoint.id === null) {
      onCreateControlPoint(controlPoint);
      this.setState({ isChange: false });
    }
  }

  onClickNewControlPoint(controlPoint) {
    const { onSelectControlPoint, onSetViewPanel, viewPanelItems } = this.props;

    onSelectControlPoint(controlPoint);
    onSetViewPanel(viewPanelItems.createControlPoint);
    this.setState({ controlPoint, isChange: false });
  }

  render() {
    const { controlPoint, isChange } = this.state;
    if (controlPoint === null) return null;

    return (
      <div className={styles.createControlPointsContainer} style={{ height: `${window.innerHeight - 100}px` }}>
        <div className={styles.inLineContainer}>
          <GeocoderSearch onHadleSelectSearchResult={this.onHadleSelectSearchResult.bind(this)} />

          <div
            className={styles.leftPanel}
            onClick={() => {
              this.onCloseClick();
            }}
          >
            <TooltipWrapper title={"Закрыть"} position="left">
              <HighlightOffIcon style={{ color: "red" }} />
            </TooltipWrapper>
          </div>
        </div>

        <div className={styles.createControlPointInputContainer}>
          <TextField
            id="outlined-basic"
            label="Наименование контрольной точки *"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={controlPoint.title === null ? "" : controlPoint.title}
            onChange={(e) => {
              this.onHandleChangeStore("title", e.target.value);
            }}
          />
        </div>

        <div className={styles.createControlPointInputContainer}>
          <TextField
            id="outlined-basic"
            label="Адрес *"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={controlPoint.address === null ? "" : controlPoint.address}
            onChange={(e) => {
              this.onHandleChangeStore("address", e.target.value);
            }}
          />
        </div>

        <div className={styles.createControlPointInputContainer}>
          <TextField
            id="outlined-basic"
            label="Адрес по локации"
            variant="outlined"
            size="small"
            fullWidth={true}
            value={controlPoint.geocoderAddress === null ? "" : controlPoint.geocoderAddress}
          />
        </div>

        <div className={styles.createControlPointInputContainer}>
          <TextField
            id="outlined-basic"
            label="Радиус (м)"
            variant="outlined"
            size="small"
            type="number"
            InputProps={{
              sx: { width: "300px" },
              inputProps: { min: 1 },
            }}
            value={controlPoint.radius}
            onChange={(e) => {
              this.onHandleChangeStore("radius", e.target.value, true);
            }}
          />
        </div>

        <div className={styles.createControlPointInputContainer}>
          <TextField
            id="outlined-basic"
            label="Максимальная засчитываемая скорость (км./ч.)"
            variant="outlined"
            size="small"
            type="number"
            InputProps={{
              sx: { width: "300px" },
              inputProps: { min: 0 },
            }}
            value={controlPoint.maxSpeed}
            onChange={(e) => {
              this.onHandleChangeStore("maxSpeed", e.target.value, true);
            }}
          />
        </div>

        <div className={styles.inLineContainer} style={{ width: "100%" }}>
          <div className={styles.createControlPointInputContainer}>
            <textarea
              style={{ width: "600px", fontFamily: "Open Sans" }}
              rows={2}
              value={controlPoint.description}
              onChange={(e) => {
                this.onHandleChangeStore("description", e.target.value);
              }}
            />
            {controlPoint.id !== null ? (
              <ButtonPrimary
                title={"Создать новую контрольнут точку на основе текущей"}
                handleClick={(e) => {
                  e.stopPropagation();
                  this.onClickNewControlPoint({
                    id: null,
                    title: null,
                    latitude: controlPoint.latitude,
                    longitude: controlPoint.longitude,
                    radius: controlPoint.radius,
                    maxSpeed: controlPoint.maxSpeed,
                    address: null,
                    geocoderAddress: null,
                    description: null,
                  });
                }}
              ></ButtonPrimary>
            ) : null}
          </div>

          {isChange ? (
            <div className={styles.leftPanel}>
              <ButtonPrimary
                title={controlPoint.id === null ? "Создать" : "Обновить"}
                handleClick={this.onSaveHandler.bind(this)}
              ></ButtonPrimary>
            </div>
          ) : null}
        </div>

        <div className={styles.createControlPointMapContainer}>
          <MapCreateControlPoint controlPoint={controlPoint} onLocationChange={this.onLocationChange.bind(this)} />
        </div>
      </div>
    );
  }
}

export default withGeocoder(withLogisticControlPoints(CreateControlPoint));
